
export const splashState = {
    shown:false,
}